import { months } from "@root/webConstants";

type FormatType = 'YYYY/MM/DD HH:MM AM/PM' | 'YYYY/MM/DD' | 'DD/MM/YYYY' | 'MONTH DD';

export const dateConverter = (givenDate: string, format: FormatType): string => {
    if (!givenDate) {
        return '-'
    }
    const date = new Date(givenDate);

    // Check for invalid date
    if (isNaN(date.getTime())) {
        return '-';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    let formattedDate = '';

    switch (format) {
        case 'YYYY/MM/DD HH:MM AM/PM': {
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 24-hour time to 12-hour format
            formattedDate = `${year}/${month}/${day} ${hours}:${minutes} ${ampm}`;
            break;
        }
        case 'YYYY/MM/DD': {
            formattedDate = `${year}/${month}/${day}`;
            break;
        }
        case 'DD/MM/YYYY': {
            formattedDate = `${day}/${month}/${year}`;
            break;
        }
        case 'MONTH DD': {
            formattedDate = `${months[Number(month) - 1]} ${day}`;
            break;
        }
    }

    return formattedDate;
};

export const generateRandomId = (type: string) => {
    const dateInMiliSec = new Date().getMilliseconds(); // 0-999
    const randomNum = Math.floor(Math.random() * 1000); // Generate a random number between 0 and 999
    const timestamp = Date.now(); // Get the current timestamp in milliseconds

    // Combine them to create a unique ID
    const randomId = `${type || ''}-${timestamp}-${dateInMiliSec}-${randomNum}`;
    return randomId;
}

export const groupByDate = (array: any[]) => {
    if (array && array.length > 0) {
        const grouped = array.reduce((acc, obj) => {
            const date = obj?.updatedAt?.split("T")[0]; // Extract the date part
            if (!acc[date]) {
                acc[date] = []; // Initialize an array for this date if it doesn't exist
            }
            // Push the object with an additional `isSelected` property set to `false`
            acc[date].push({ ...obj, isSelected: false });
            return acc;
        }, {});

        // Transform the grouped object into an array of objects with the desired structure
        return Object.entries(grouped).map(([date, chats]) => ({
            date: dateConverter(date, 'MONTH DD'),
            chats
        }));
    }
    return []; // Return an empty array if the input array is invalid or empty
};